import React from 'react'
import classes from './MealsSummary.module.css'

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Insatiable Flavors Instantly at Your Door!</h2>
      <p>
        A genuine fine-dining experience awaits. It’s time to enjoy the finer
        things in life. Nothing brings people together like good food. Creativity
        is always on our menu.
      </p>
      <p>Your belly knows the best!</p>
    </section>
  );
}

export default MealsSummary